import request from '@/utils/request';
import { ICommonRes, IUserInfoRes } from '../interface';
import {
  IGetWXInfoRes,
  IOauth2StepCode,
  IAuthenticateCode,
  IUserLoginLogRes,
  INeedResetPasswordRes
} from './interface';

// 获取当前账号的用户信息
export const getUserInfo = () => {
  return request.get<IUserInfoRes>('/v2/user/data');
};

// 获取用户登录记录信息
export const getUserLoginLogList = () => {
  return request.get<IUserLoginLogRes>('/v2/user/info');
};

// 用户是否需要重置密码
export const getNeedResetPassword = () => {
  return request.get<INeedResetPasswordRes>('/v2/user/need_reset_password');
};

// 重置密码
export const resetPassword = (params: object) => {
  return request.post<ICommonRes>('/v2/user/reset_password', params);
};

// 用户忘记密码，通过手机号码获取验证码
export const getVerificationCode = (params: object) => {
  return request.post<ICommonRes>('/v2/user/forget_password', params);
};

export const setNewPassword = (params: object) => {
  return request.post<ICommonRes>('/v2/user/forget_password/reset', params);
};

// 发送语音验证码
export const sendVoiceMessage = () => {
  return request.post<ICommonRes>('/v2/user/forget_password/tts');
};

export const logout = () => {
  return request.get('/v2/user/logout');
};

export const getOauth2StepCode = (params: object) => {
  return request.post<IOauth2StepCode>('/v2/oauth2/2step/sms', params);
};

export const getOauth2StepWXCode = () => {
  return request.post<IOauth2StepCode>('/v2/oauth2/2step/wxMs');
};

export const getOauth2StepVoiceCode = () => {
  return request.post<ICommonRes>('/v2/oauth2/2step/tts');
};

export const postAuthenticateCode = (params: object) => {
  return request.post<IAuthenticateCode>('/v2/oauth2/2step', params);
};

export const postAuthenticateWXCode = (params: object) => {
  return request.post<IAuthenticateCode>('/v2/oauth2/2step/wxMsOAuth', params);
};

export const getWXInfo = () => {
  return request.get<IGetWXInfoRes>('/v2/oauth2/2step/wx');
};

export const postWXAuthenticateCode = (params: object) => {
  return request.post<IAuthenticateCode>('/v2/oauth2/2step/wxOAuth', params);
};
